import cx from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext';

export default function HeaderOverlay() {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      className={cx(
        // This backdrop is only meant to cover the Header due to a stacking context issue between it and the search bar container, hence the '-top-80' and 'h-80' classes
        'pointer-events-none absolute -top-80 left-0 z-10 h-80 w-full bg-canvas-overlay transition-all duration-300',
        isSearchBarFocused ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}
